import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useMutation } from 'react-apollo';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextFieldCheckout from '../../../components/TextField/TextFieldCheckout';
import { ADICIONAR_CARTAO_CREDITO_PROFISSIONAL_SAUDE_CLIENTE_PAGAMENTO } from '../../../graphql/mutations';
import Notification from '../../../components/notification/Notification';
import Number from '../../../utils/number';
import string from '../../../utils/string';
import {
  cpfCnpjFormatted,
  phoneFormatted,
  cepFormatted,
} from '../../../utils/masks';
import enterpriseIcon from '../../../assets/images/enterpriseIcon.svg';
import logoWhite from '../../../assets/images/logoWhite.svg';
import mailIcon from '../../../assets/images/mailIcon.svg';
import phoneIcon from '../../../assets/images/phoneIcon.svg';
import walletIcon from '../../../assets/images/walletIcon.svg';
import adressIcon from '../../../assets/images/adressIcon.svg';
import creditCardIcon from '../../../assets/images/creditCardIcon.svg';

const notificationDefault = {
  variant: '',
  message: '',
  isOpen: false,
};

const Checkout = ({ dadosProfissional, handlePagamentoSucesso,valor }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [notification, setNotification] = useState({
    ...notificationDefault,
  });

  const [adicionarCartaoCreditoAProfissionalSaudeClientePagamento] =
    useMutation(ADICIONAR_CARTAO_CREDITO_PROFISSIONAL_SAUDE_CLIENTE_PAGAMENTO);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const profissionalSaudeId = searchParams.get('idProfissional');

  const [formData, setFormData] = useState({
    cardNumber: '',
    holder: '',
    expirationDate: null,
    securityCode: '',
  });

  const [dadosErrors, setDadosErrors] = useState({
    cardNumber: '',
    holder: '',
    expirationDate: null,
    securityCode: '',
  });

  const handleChangeCartaoCreditoField = (campo, value) => {
    setFormData({
      ...formData,
      [campo]: value,
    });

    setDadosErrors({
      ...dadosErrors,
      [campo]:
        campo === 'cardNumber' ? !string.validaCartaoCredito(value) : !value,
    });
  };

  const verificaCamposPreenchidos = () => {
    return (
      !string.validaCartaoCredito(formData.cardNumber) ||
      !formData.holder ||
      !formData.expirationDate ||
      !formData.securityCode
    );
  };

  const handleSubmitCartaoCredito = async (e) => {
    e.preventDefault();
    if (verificaCamposPreenchidos()) {
      setNotification({
        variant: 'error',
        isOpen: true,
        message: 'Por favor, verifique os campos do cartão de crédito.',
      });
      return;
    }

    try {
      setLoadingSubmit(true);
      const cartaoCredito = {
        cardNumber: string.removeSpecialChars(formData.cardNumber),
        holder: formData.holder,
        expirationDate: moment(
          string.removeSpecialChars(formData.expirationDate),
          'MMYYYY'
        )
          .startOf('month')
          .format('YYYY-MM-DD'),
        securityCode: formData.securityCode,
      };

      await adicionarCartaoCreditoAProfissionalSaudeClientePagamento({
        variables: {
          cartaoCredito,
          profissionalSaudeId,
        },
      });

      setNotification({
        variant: 'success',
        isOpen: true,
        message: 'Cartão cadastrado com sucesso.',
      });

      handlePagamentoSucesso && handlePagamentoSucesso();
    } catch ({ graphQLErrors }) {
      if (graphQLErrors) {
        setNotification({
          variant: 'error',
          isOpen: true,
          message: graphQLErrors[0].message,
        });
      }
    }
    setLoadingSubmit(false);
  };

const enderecoCompleto = [
  dadosProfissional?.endereco?.nomeLogradouro,
  dadosProfissional?.endereco?.numero,
  dadosProfissional?.endereco?.bairro,
  dadosProfissional?.endereco?.municipio?.nome &&
    `${dadosProfissional.endereco.municipio.nome}-${dadosProfissional.endereco.municipio.uf}`,
  cepFormatted(dadosProfissional?.endereco?.cep || "")
].filter(Boolean).join(", ");

  return (
    <PageContainer>
      <InformacoesPagamento>
        <Header>
          <Logo src={logoWhite} alt="App Health Logo" />
        </Header>

        <Content>
          <TituloPrincipal>Checkout</TituloPrincipal>

          <DadosContent>
            <DadosClinicaEProduto>
              <Title> Dados do profissional saúde </Title>
              <Label> {dadosProfissional?.nome} </Label>
              <Label>
                {' '}
                <Icon src={enterpriseIcon} /> CPF:{' '}
                {cpfCnpjFormatted(dadosProfissional?.cpf)}{' '}
              </Label>
              <Label>
                {' '}
                <Icon src={phoneIcon} />{' '}
                {phoneFormatted(dadosProfissional?.telefone)}{' '}
              </Label>
              <Label>
                {' '}
                <Icon src={mailIcon} /> {dadosProfissional?.email}{' '}
              </Label>
              <Label>
                {' '}
                <Icon src={adressIcon} />
                {enderecoCompleto}
              </Label>
            </DadosClinicaEProduto>

            <DadosClinicaEProduto>
              <Title> Dados do produto </Title>
              <Item>
                Produto:
                <Label>
                  {' '}
                  <Icon src={enterpriseIcon} /> IA Profissional{' '}
                </Label>
              </Item>
              <Item>
                Modalidade de pagamento:
                <Label>
                  {' '}
                  <Icon src={walletIcon} /> Recorrente{' '}
                </Label>
              </Item>
              <Item>
                Valor do investimento:
                <LabelValorPlano>
                  {' '}
                  {Number.currencyFormat(valor)} / mês{' '}
                </LabelValorPlano>
              </Item>
              <Item>
                Forma de Pagamento
                <Label>
                  {' '}
                  <Icon src={creditCardIcon} /> Cartão de Crédito{' '}
                </Label>
              </Item>
            </DadosClinicaEProduto>
          </DadosContent>
        </Content>
      </InformacoesPagamento>

      <CheckoutContainer>
        <Form>
          <TituloCheckout> Pagamento </TituloCheckout>

          <TextFieldCheckout
            label={'Nome igual ao do cartão:'}
            variant="outlined"
            color={'white'}
            field={formData.holder}
            maxLength={50}
            handleChange={(e) =>
              handleChangeCartaoCreditoField('holder', e.target.value)
            }
          />

          <TextFieldCheckout
            label={'Número do cartão:'}
            variant="outlined"
            color={'white'}
            mask={'creditCard'}
            field={formData.cardNumber}
            handleChange={(e) =>
              handleChangeCartaoCreditoField('cardNumber', e.target.value)
            }
          />

          <ValidadeECvc>
            <TextFieldCheckout
              label={'Validade:'}
              variant="outlined"
              color={'white'}
              field={formData.expirationDate}
              mask={'dataValidade'}
              handleChange={(e) =>
                handleChangeCartaoCreditoField('expirationDate', e.target.value)
              }
            />

            <TextFieldCheckout
              label={'CVC:'}
              variant="outlined"
              color={'white'}
              field={formData.securityCode}
              mask={'creditCardSecureCode'}
              handleChange={(e) =>
                handleChangeCartaoCreditoField('securityCode', e.target.value)
              }
            />
          </ValidadeECvc>

          <SubmitButton
            onClick={handleSubmitCartaoCredito}
            disabled={loadingSubmit}
          >
            Confirmar
            {loadingSubmit && (
              <CircularProgressStyled color="inherit" size={12} />
            )}
          </SubmitButton>
        </Form>
      </CheckoutContainer>

      <Notification
        close={() => {
          setNotification({
            ...notificationDefault,
          });
        }}
        reset={() => {
          setNotification({
            ...notificationDefault,
          });
        }}
        isOpen={notification.isOpen}
        variant={notification.variant}
        message={notification.message}
      />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden scroll;
  @media (max-width: 750px) {
    width: 100%;
    flex-direction: column;
    overflow: hidden scroll;
  }
`;

const InformacoesPagamento = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  @media (max-width: 750px) {
    width: 100%;
  }
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0 10% 20% 10%;
  justify-content: center;
`;

const Logo = styled.img`
  width: 180px;
  margin-left: 5%;
`;

const Icon = styled.img`
  max-height: 20px;
  margin-right: 8px;
`;

const Label = styled.p`
  display: flex;
  flex-direction: row;
  font-family: 'Poppins';
  font-weight: 500;
  font-size: 14px;
  color: #505050;
  align-items: center;
`;

const LabelValorPlano = styled(Label)`
  font-size: 24px;
  color: #219a97;
  font-weight: 900;
  margin: 4px;
`;

const Item = styled.h3`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
  color: #505050;
  margin: 2px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  height: 120px;
  background-color: #34a3a0;
  align-content: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-left: 8%;
`;

const DadosContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  @media (max-width: 750px) {
    flex-direction: column;
  }
`;

const DadosClinicaEProduto = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 100%;
  margin-right: 20px;
`;

const ValidadeECvc = styled.div`
  display: flex;
  flex-direction: row;
`;

const CheckoutContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  background-color: #505050;
`;

const Title = styled.h1`
  font-family: 'Poppins';
  font-weight: 900;
  font-size: 24px;
  color: #505050;
  margin-bottom: 18px;
`;

const TituloPrincipal = styled(Title)`
  font-size: 54px;
`;

const TituloCheckout = styled(Title)`
  color: #fff;
`;

const SubmitButton = styled.button`
  margin-top: 12px;
  color: #fff;
  font-size: 14px;
  border: none;
  outline: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  position: static;
  width: 100%;
  height: 56px;
  left: 0px;
  top: 327px;
  background: #219a97;
  box-shadow: 12px 16px 24px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
`;

const CircularProgressStyled = styled(CircularProgress)`
  margin-left: 10px;
`;

export default Checkout;
